import { render, staticRenderFns } from "./OtherEnrollmentFoundMessage.vue?vue&type=template&id=75ccbc8c&scoped=true"
import script from "./OtherEnrollmentFoundMessage.vue?vue&type=script&lang=ts"
export * from "./OtherEnrollmentFoundMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ccbc8c",
  null
  
)

export default component.exports